import React, { useState } from 'react';
import PropTypes from "prop-types";
//import Components
//import Header from './Header.jsx';
import Sidebar from './Sidebar.jsx';
import Footer from './Footer.jsx';
import LanguageAwareWrapper from '../../Components/Common/LanguageAwareWrapper';
import SubscriptionWarning from '../../Components/Common/SubscriptionWarning';
//import actions
import {
    changeLayout,
    changeSidebarTheme,
    changeLayoutMode,
    changeLayoutWidth,
    changeLayoutPosition,
    changeTopbarTheme,
    changeLeftsidebarSizeType,
    changeLeftsidebarViewType
} from "../../store/actions";
//redux
import { useSelector, useDispatch } from "react-redux";

const Layout = (props) => {
  // Quản lý trạng thái thu gọn sidebar ở Layout
  const [isCollapsed, setIsCollapsed] = useState(false);

  const sidebarWidth = isCollapsed ? 60 : 240;

  return (
    <LanguageAwareWrapper>
      <div>
        <SubscriptionWarning sidebarWidth={sidebarWidth} />
        <Sidebar isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
        <div
          className="transition-all duration-300 min-h-screen bg-gray-50"
          style={{
            marginLeft: sidebarWidth,
            width: `calc(100% - ${sidebarWidth}px)`
          }}
        >
          <div className="p-4 w-full">
            {props.children}
            <Footer />
          </div>
        </div>
      </div>
    </LanguageAwareWrapper>
  );
};

Layout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.func,
    PropTypes.element
  ]),
};

export default Layout;
